export class BindError extends Error {}
